/* =========================================
   DR PEN CUSTOM - Free Delivery Progress
   ========================================= */

(function () {
  const FREE_DELIVERY_THRESHOLD = 3000; // £30.00 in pence

  function formatMoney(pence) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format(pence / 100);
  }

  function getProgressContainer() {
 let container = document.querySelector('#drpen-free-delivery');

if (container && container.closest('.drawer__footer')) {
  return container;
}

if (container) {
  container.remove();
}

  const subtotalRow = document.querySelector(
  '#CartDrawerForm .drawer__footer .cart__item-sub.cart__item-row'
);

if (!subtotalRow) {
  return null;
}

container = document.createElement('div');
container.id = 'drpen-free-delivery';
container.className = 'drpen-free-delivery';

subtotalRow.parentNode.insertBefore(container, subtotalRow);

return container;
}

  function addStyles() {
    if (document.querySelector('#drpen-free-delivery-styles')) {
      return;
    }

    const styles = document.createElement('style');
    styles.id = 'drpen-free-delivery-styles';

    styles.textContent = `
      .drpen-free-delivery {
        margin: 4px 0 28px;
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
        text-align: center;
      }

      .drpen-free-delivery__message {
        margin-bottom: 12px;
        color: #111;
        font-size: 14px;
        line-height: 1.4;
      }

      .drpen-free-delivery__track {
        width: 100%;
        height: 4px;
        overflow: hidden;
        background: #e8e8e8;
      }

      .drpen-free-delivery__progress {
        height: 100%;
        background: #171f2c;
        transition: width 0.3s ease;
      }
    `;

    document.head.appendChild(styles);
  }

  function updateFreeDelivery(cart) {
    if (!cart || typeof cart.total_price !== 'number') {
      return;
    }

    addStyles();

    const container = getProgressContainer();

    if (!container) {
  setTimeout(function () {
    updateFreeDelivery(cart);
  }, 150);

      return;
    }

    const basketTotal = cart.total_price;
    const amountRemaining = Math.max(
      FREE_DELIVERY_THRESHOLD - basketTotal,
      0
    );

    const progress = Math.min(
      (basketTotal / FREE_DELIVERY_THRESHOLD) * 100,
      100
    );

    if (basketTotal >= FREE_DELIVERY_THRESHOLD) {
      container.innerHTML = `
        <div class="drpen-free-delivery__message">
          You've unlocked <strong>FREE Tracked 24 delivery</strong>
        </div>

        <div class="drpen-free-delivery__track">
          <div
            class="drpen-free-delivery__progress"
            style="width: 100%;"
          ></div>
        </div>
      `;
    } else {
      container.innerHTML = `
        <div class="drpen-free-delivery__message">
          Add <strong>${formatMoney(amountRemaining)}</strong>
more to unlock FREE Tracked 24 delivery
        </div>

        <div class="drpen-free-delivery__track">
          <div
            class="drpen-free-delivery__progress"
            style="width: ${progress}%;"
          ></div>
        </div>
      `;
    }
  }

  function fetchCurrentCart() {
    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Unable to retrieve basket');
        }

        return response.json();
      })
      .then(function (cart) {
        updateFreeDelivery(cart);
      })
      .catch(function (error) {
        console.warn('Dr Pen free delivery progress:', error);
      });
  }

  function refreshFreeDeliveryProgress() {
  fetchCurrentCart();

  setTimeout(fetchCurrentCart, 150);
  setTimeout(fetchCurrentCart, 400);
}

document.addEventListener('DOMContentLoaded', fetchCurrentCart);

document.addEventListener('cart:updated', function () {
  refreshFreeDeliveryProgress();
});

document.addEventListener('ajaxProduct:added', function () {
  refreshFreeDeliveryProgress();
});

document.addEventListener('drawerOpen', function () {
  refreshFreeDeliveryProgress();
});
})();
/* END DR PEN CUSTOM - Free Delivery Progress */
/* =========================================
   DR PEN CUSTOM - Dispatch Countdown
   ========================================= */
   function initDrPenDeliveryCountdown() {
  var countdownTime = document.getElementById('drpen-countdown-time');
  var dispatchDay = document.getElementById('drpen-dispatch-day');

  if (!countdownTime || !dispatchDay) return;

  var cutoffHour = 15; // 3pm cut-off

  function isWorkingDay(date) {
    var day = date.getDay();
    return day !== 0 && day !== 6; // Excludes Sunday and Saturday
  }

  function getWeekdayName(date) {
    var today = new Date();
    var tomorrow = new Date();

    tomorrow.setDate(today.getDate() + 1);

    if (date.toDateString() === today.toDateString()) {
      return 'today';
    }

    if (date.toDateString() === tomorrow.toDateString()) {
      return 'tomorrow';
    }

    return date.toLocaleDateString('en-GB', { weekday: 'long' });
  }

  function getNextDispatchCutoff(now) {
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (isWorkingDay(now) && now < cutoff) {
      return cutoff;
    }

    do {
      cutoff.setDate(cutoff.getDate() + 1);
      cutoff.setHours(cutoffHour, 0, 0, 0);
    } while (!isWorkingDay(cutoff));

    return cutoff;
  }

  function getDispatchDate(now) {
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    if (isWorkingDay(now) && now < cutoff) {
      return now;
    }

    var dispatch = new Date(now);

    do {
      dispatch.setDate(dispatch.getDate() + 1);
    } while (!isWorkingDay(dispatch));

    return dispatch;
  }

  function updateCountdown() {
    var now = new Date();
    var dispatchCutoff = getNextDispatchCutoff(now);
    var dispatchDate = getDispatchDate(now);

    var diff = dispatchCutoff - now;

    var hours = Math.floor(diff / (1000 * 60 * 60));
    var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    countdownTime.textContent = hours + 'h ' + minutes + 'm';
    dispatchDay.textContent = getWeekdayName(dispatchDate);
  }

  updateCountdown();

  if (!window.drpenDeliveryCountdownInterval) {
    window.drpenDeliveryCountdownInterval = setInterval(updateCountdown, 60000);
  }
}

document.addEventListener('DOMContentLoaded', initDrPenDeliveryCountdown);
document.addEventListener('shopify:section:load', initDrPenDeliveryCountdown);
setTimeout(initDrPenDeliveryCountdown, 500);
/* END DR PEN CUSTOM - Dispatch Countdown */

(function () {
  function normalise(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getVariantData() {
    var element = document.getElementById('DrPenVariantImageData');

    if (!element) {
      return null;
    }

    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      console.warn('Dr Pen variant image data error:', error);
      return null;
    }
  }

  function getOptionName(option) {
    if (typeof option === 'string') {
      return option;
    }

    if (option && option.name) {
      return option.name;
    }

    return '';
  }

  function isColourName(value) {
    var name = normalise(value);

    return (
      name === 'colour' ||
      name === 'color' ||
      name === 'ink colour' ||
      name === 'ink color'
    );
  }

  function getColourIndex(data) {
    var index;

    for (index = 0; index < data.options.length; index += 1) {
      if (isColourName(getOptionName(data.options[index]))) {
        return index;
      }
    }

    return -1;
  }

  function createImageMap(data, colourIndex) {
    var imageMap = {};

    data.variants.forEach(function (variant) {
      if (!variant) {
        return;
      }

      if (!variant.image) {
        return;
      }

      if (!Array.isArray(variant.options)) {
        return;
      }

      var colourValue = variant.options[colourIndex];

      if (!colourValue) {
        return;
      }

      if (!imageMap[colourValue]) {
        imageMap[colourValue] = variant.image;
      }
    });

    return imageMap;
  }

  function applyVariantImages() {
    var data = getVariantData();

    if (!data) {
      return;
    }

    if (!Array.isArray(data.options)) {
      return;
    }

    if (!Array.isArray(data.variants)) {
      return;
    }

    var colourIndex = getColourIndex(data);

    if (colourIndex === -1) {
      return;
    }

    var imageMap = createImageMap(data, colourIndex);

    var labels = document.querySelectorAll(
      'label.kit-radio[data-option-name]'
    );

    labels.forEach(function (label) {
      var optionName = label.getAttribute('data-option-name');

      if (!isColourName(optionName)) {
        return;
      }

      var input = label.querySelector('input[type="radio"]');
      var swatch = label.querySelector('.kit-swatch');

      if (!input || !swatch) {
        return;
      }

      var imageUrl = imageMap[input.value];

      if (!imageUrl) {
        label.classList.remove('drpen-variant-image-ready');
        swatch.style.removeProperty('--drpen-variant-image');
        return;
      }

      if (imageUrl.indexOf('//') === 0) {
        imageUrl = window.location.protocol + imageUrl;
      }

      swatch.style.setProperty(
        '--drpen-variant-image',
        'url("' + imageUrl + '")'
      );

      label.classList.add('drpen-variant-image-ready');
    });
  }

  function initialiseVariantImages() {
    applyVariantImages();
    window.setTimeout(applyVariantImages, 150);
    window.setTimeout(applyVariantImages, 500);
  }

 document.addEventListener(
  'DOMContentLoaded',
  initialiseVariantImages
);

document.addEventListener(
  'shopify:section:load',
  initialiseVariantImages
);

document.addEventListener('change', function (event) {
  if (
    event.target.matches(
      'label.kit-radio[data-option-name] input[type="radio"]'
    )
  ) {
    window.setTimeout(applyVariantImages, 50);
    window.setTimeout(applyVariantImages, 200);
    window.setTimeout(applyVariantImages, 500);
  }
});

function observeVariantPicker() {
  var productArea =
    document.querySelector('.product-section') ||
    document.querySelector('[data-section-type="product"]') ||
    document.querySelector('main');

  if (!productArea) {
    return;
  }

  if (productArea.dataset.drpenVariantObserver === 'true') {
    return;
  }

  productArea.dataset.drpenVariantObserver = 'true';

  var updateTimer;

  var observer = new MutationObserver(function () {
    window.clearTimeout(updateTimer);

    updateTimer = window.setTimeout(function () {
      applyVariantImages();
    }, 0);
  });

  observer.observe(productArea, {
    childList: true,
    subtree: true
  });
}

document.addEventListener(
  'DOMContentLoaded',
  observeVariantPicker
);

window.setTimeout(initialiseVariantImages, 750);
window.setTimeout(observeVariantPicker, 800);
})();
(function () {
  function prepareScrollableCardSwatches() {
    var groups = document.querySelectorAll(
      '.grid-product__colors'
    );

    groups.forEach(function (group) {
      if (
        group.classList.contains(
          'drpen-card-scroll-ready'
        )
      ) {
        return;
      }

      var swatches = Array.from(
        group.querySelectorAll(
          '.kit-swatch[data-variant-image]'
        )
      );

      if (!swatches.length) {
        return;
      }

      var count = document.createElement('span');

      count.className =
        'drpen-card-colour-count';

      count.textContent =
        swatches.length +
        (swatches.length === 1
          ? ' colour available'
          : ' colours available');

      var viewport = document.createElement('div');

      viewport.className =
        'drpen-card-swatch-scroll';

      swatches.forEach(function (swatch) {
        var imageUrl = swatch.getAttribute(
          'data-variant-image'
        );

        swatch.classList.add(
          'drpen-card-variant-thumbnail'
        );

        if (imageUrl) {
          if (imageUrl.indexOf('//') === 0) {
            imageUrl =
              window.location.protocol + imageUrl;
          }

          swatch.style.setProperty(
            '--drpen-card-variant-image',
            'url("' + imageUrl + '")'
          );
        }

        viewport.appendChild(swatch);
      });

      group.innerHTML = '';
      group.appendChild(count);
      group.appendChild(viewport);

      group.classList.add(
        'drpen-card-scroll-ready'
      );
    });
  }

  function scheduleScrollableCardSwatches() {
    prepareScrollableCardSwatches();

    window.setTimeout(
      prepareScrollableCardSwatches,
      150
    );

    window.setTimeout(
      prepareScrollableCardSwatches,
      500
    );
  }

  document.addEventListener(
    'DOMContentLoaded',
    scheduleScrollableCardSwatches
  );

  document.addEventListener(
    'shopify:section:load',
    scheduleScrollableCardSwatches
  );

  window.setTimeout(
    scheduleScrollableCardSwatches,
    750
  );
})();
(function () {
  function addCollectionColourCounts() {
    var groups = document.querySelectorAll(
      '.grid-product__colors'
    );

    groups.forEach(function (group) {
      var card = group.closest('.grid-product');

      if (!card) {
        return;
      }

      if (
        card.querySelector(
          '.drpen-collection-colour-count'
        )
      ) {
        return;
      }

      var swatches = group.querySelectorAll(
        '.kit-swatch[data-variant-image]'
      );

      if (!swatches.length) {
        return;
      }

      var count = document.createElement('div');

      count.className =
        'drpen-collection-colour-count';

      count.textContent =
        swatches.length +
        (swatches.length === 1
          ? ' colour available'
          : ' colours available');

      group.insertAdjacentElement(
        'afterend',
        count
      );
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    addCollectionColourCounts
  );

  document.addEventListener(
    'shopify:section:load',
    addCollectionColourCounts
  );

  window.setTimeout(
    addCollectionColourCounts,
    500
  );
})();